import {
  Box,
  Grid,
  Typography,
  makeStyles,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { Modal, colors } from 'design-system';
import { ChevronLeft, ChevronRight } from 'react-feather';
import Carousel from 'react-material-ui-carousel';

export const useStylesHelpModal = makeStyles({
  navigateIcon: {
    '&.MuiIconButton-root': {
      backgroundColor: 'transparent',
    },
    '&.MuiIconButton-root:hover': {
      opacity: '1!important',
    },
  },
  navigationWrapper: {
    top: -100,
    '&:hover button': {
      opacity: '1!important',
      filter: 'none!important',
      backgroundColor: 'transparent!important',
    },
  },
  indicatorIcons: {
    '&.MuiIconButton-root': {
      color: '#EAEAEA',
      '&:hover': {
        color: '#4A4B4E',
      },
    },
    '& > svg': {
      fontSize: 16,
    },
  },
  indicatorIconWrapper: {
    marginTop: 22,
  },
  rootContainer: {
    paddingLeft: 10,
    paddingRight: 10,
  },
  rootContainerLarge: {
    paddingLeft: 50,
    paddingRight: 50,
  },
  textTitle: {
    fontSize: 16,
    fontWeight: 700,
  },
  textDescription: {
    fontSize: 15,
    fontWeight: 400,
    maxWidth: 345,
  },
  textDescriptionExemption: {
    fontSize: 15,
    fontWeight: 400,
    maxWidth: 450,
  },
  textNote: {
    fontSize: 13,
    fontWeight: 500,
    maxWidth: 345,
  },
  textPx: {
    color: colors.bright_turquoise,
  },
});

type Props = {
  open: boolean;
  onCloseModal: () => void;
};

const DeductibleHelpModal = ({ onCloseModal, open }: Props): JSX.Element => {
  const classes = useStylesHelpModal();
  const theme = useTheme();
  const smQuery = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <Modal
      data-testid="deductible-help-modal"
      title="¿Qué es el deducible?"
      open={open}
      maxWidth="sm"
      onCloseRequested={onCloseModal}
    >
      <Grid
        container
        item
        justifyContent="center"
        className={smQuery ? classes.rootContainer : classes.rootContainerLarge}
      >
        <Carousel
          data-testid="carousel-deductible"
          NextIcon={<ChevronRight size={30} color={colors.bright_turquoise} />}
          PrevIcon={<ChevronLeft size={30} color={colors.bright_turquoise} />}
          navButtonsAlwaysVisible={!smQuery}
          navButtonsAlwaysInvisible={smQuery}
          animation="slide"
          interval={smQuery ? 5000 : 15000000000}
          navButtonsProps={{
            className: classes.navigateIcon,
          }}
          navButtonsWrapperProps={{
            className: classes.navigationWrapper,
          }}
          indicatorContainerProps={{ className: classes.indicatorIconWrapper }}
          indicatorIconButtonProps={{
            className: classes.indicatorIcons,
          }}
          activeIndicatorIconButtonProps={{
            style: {
              color: colors.bright_turquoise,
            },
          }}
        >
          <Grid item container justifyContent="center" data-testid="first-page">
            <Grid item>
              <img
                src="/svg/img-deducible.svg"
                alt="deducible"
                width={240}
                height={240}
              />
            </Grid>

            <Grid item container spacing={1}>
              <Grid item xs={12}>
                <Typography align="center" className={classes.textTitle}>
                  Deducible fijo
                </Typography>
              </Grid>
              <Grid item xs={12} container justifyContent="center">
                <Typography
                  align="center"
                  color="secondary"
                  className={classes.textDescription}
                >
                  El deducible es el monto que acuerdo pagar de mi bolsillo por
                  daños de una pérdida o accidente, antes de que mi seguro cubra
                  el resto.
                </Typography>
              </Grid>
              <Grid item xs={12} container justifyContent="center">
                <Typography
                  align="center"
                  color="secondary"
                  className={classes.textDescription}
                >
                  <strong>Por ejemplo:</strong> Si tu deducible fijo es de $600
                  y los daños por reparación de tu auto suman $3,000, tu
                  pagarías $600 y tu aseguradora pagaría los $2,400 restantes
                  para reparar tu automóvil.
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            container
            justifyContent="center"
            data-testid="second-page"
          >
            <Grid item>
              <img
                src="/svg/img-deductible-percentage.svg"
                alt="deducible percentage"
                width={240}
                height={240}
              />
            </Grid>

            <Grid item container spacing={1}>
              <Grid item xs={12}>
                <Typography align="center" className={classes.textTitle}>
                  Deducible de pérdida porcentual
                </Typography>
              </Grid>
              <Grid item xs={12} container justifyContent="center">
                <Typography
                  className={classes.textDescription}
                  align="center"
                  color="secondary"
                >
                  <strong>Por ejemplo:</strong> Si los daños por reparación de
                  tu auto suman $3,000, tu pagarías un 30%* de la pérdida ($900)
                  y tu aseguradora pagaría los $2,100 restantes para reparar tu
                  automóvil.
                </Typography>
              </Grid>
              <Grid item xs={12} container justifyContent="center">
                <Typography
                  className={classes.textNote}
                  align="center"
                  color="secondary"
                >
                  *El porcentaje del deducible dependerá del tipo de deducible y
                  del plan Auto
                  <span className={classes.textPx}>PX</span>
                </Typography>
              </Grid>
              <Grid item>
                <Box sx={{ height: 16, width: 10 }} />
              </Grid>
            </Grid>
          </Grid>
        </Carousel>
      </Grid>
    </Modal>
  );
};

export default DeductibleHelpModal;
